import "react-datepicker/dist/react-datepicker.css";
import Loader from "../../../Loader/Loader";
import Modal from "../../../Shared/PopupModal/PopupModal";
import classes from "./LocationMaster.module.css";
import EditLocationMaster from "./LocationMasterEdit";
import { useContext } from "react";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";

const LocationMasterTable = ({
  locationMasterList,
  setLocationMasterList,
  deletion_list,
  show,
  checkboxeshandler,
  selectAllHandler,
  ViewTruckDetails,
  userDetails,
  truckOptions,
  deleteHandler,
  company_id,
  getTime,
  fuelRates,
  superAdmins,
  emailTemplate,
  selectedOrg,
  canedit,
  canAccess,
  canUpdate,
  checkActionPermission,
}) => {
  const { companySettingData } = useContext(MyCompanyProfileContext);

  return (
    <div className={`${classes["table-alignment"]} position-relative`}>
      <Loader show={show} />
      <table className={`${classes["table-width"]} table table-borderless`}>
        <thead>
          <tr style={{ fontSize: "14px" }}>
            <th
              className={`${classes["all"]} ${classes["sticky-th"]} pt-1 pr-1`}
            >
              <input
                type="checkbox"
                checked={
                  locationMasterList &&
                  locationMasterList.length > 0 &&
                  deletion_list.length === locationMasterList.length
                }
                onChange={selectAllHandler}
                style={{ width: "15px", height: "15px" }}
              />
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "5%" }}
            >
              Sr No.
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "15%" }}
            >
              Location
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center" }}
            >
              Address
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "10%" }}
            >
              Location Type
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "8%" }}
            >
              Pincode
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "8%" }}
            >
              Code
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "12%" }}
            >
              Customer Name
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "12%" }}
            >
              GST No
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "8%" }}
            >
              Timings
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "8%" }}
            >
              Selected Trucks
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", minWidth: "100px" }}
            >
              Halting Time (min)
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", minWidth: "120px" }}
            >
              Fuel Rate (
              {companySettingData?.default_currency?.default_currency?.cc ??
                "INR"}
              )
            </th>
            <th
              scope="col"
              className={`${classes["sticky-th"]}`}
              style={{ textAlign: "center", width: "100px", zIndex: 1 }}
            >
              Action
            </th>
          </tr>
        </thead>
        <tbody style={{ fontSize: "small" }}>
          {locationMasterList && locationMasterList.length > 0
            ? locationMasterList.map((locationMaster, index) => {
                return (
                  <tr
                    key={`${
                      locationMaster.location?.location_name ??
                      locationMaster.location_name ??
                      "-"
                    }_${index}`}
                  >
                    <td className={classes["borderforTd"]}>
                      <input
                        type="checkbox"
                        style={{ width: "15px", height: "15px" }}
                        onChange={(e) => checkboxeshandler(e, locationMaster)}
                        checked={deletion_list.includes(locationMaster)}
                      />
                    </td>
                    <td style={{ textAlign: "center", width: "3%" }}>
                      {index + 1}.
                    </td>
                    <td style={{ textAlign: "center", width: "15%" }}>
                      {locationMaster.location?.location_name ??
                        locationMaster.location_name ??
                        "-"}
                    </td>
                    <td style={{ textAlign: "center", width: "10%" }}>
                      {locationMaster.address
                        ? locationMaster.address
                        : locationMaster.addressLine1}
                    </td>
                    <td style={{ textAlign: "center", width: "10%" }}>
                      {locationMaster.type}
                    </td>
                    <td style={{ textAlign: "center", width: "10%" }}>
                      {locationMaster.pincode}
                    </td>
                    <td style={{ textAlign: "center", width: "10%" }}>
                      {locationMaster.location_code}
                    </td>
                    <td style={{ textAlign: "center", width: "12%" }}>
                      {locationMaster.customer_name
                        ? locationMaster.customer_name
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center", width: "12%" }}>
                      {locationMaster.gst_no ? locationMaster.gst_no : "-"}
                    </td>
                    <td style={{ textAlign: "center", width: "8%" }}>
                      {locationMaster.location_timings &&
                      locationMaster.location_timings.length > 0
                        ? `${locationMaster.location_timings[0].open}-${locationMaster.location_timings[0].close}`
                        : "-"}
                    </td>
                    <td style={{ textAlign: "center", width: "8%" }}>
                      {locationMaster.truck_availability &&
                      locationMaster.truck_availability.length > 0 ? (
                        <Modal
                          buttonLabel={`View trucks`}
                          buttonClass="btn btn-link"
                          content={
                            <ViewTruckDetails locationMaster={locationMaster} />
                          }
                          title={`Trucks for ${
                            locationMaster.location?.location_name ??
                            locationMaster.location_name ??
                            "-"
                          }`}
                          id="locationMaster"
                          size="md"
                          screenName="Location master - view trucks"
                          moduleName="Location master"
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td style={{ textAlign: "center", width: "8%" }}>
                      {locationMaster.halting_time !== undefined &&
                      locationMaster.halting_time !== null
                        ? `${Math.floor(locationMaster.halting_time / 60)}`
                        : "-"}
                    </td>

                    <td style={{ textAlign: "center", width: "12%" }}>
                      {locationMaster.current_rate
                        ? locationMaster.current_rate
                        : "-"}
                    </td>

                  <td>
                    <div
                      style={{
                        marginTop: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: 9,
                      }}
                    >
                        <Modal
                          buttonLabel={
                            <i className="fa fa-pencil" aria-hidden="true" />
                          }
                          buttonClass={`btn btn-link text-dark`}
                          style={{}}
                          disabled={canedit || !canUpdate}
                          content={
                            <EditLocationMaster
                              locationMaster={locationMaster}
                              index={index}
                              userDetails={userDetails}
                              truckOptions={truckOptions}
                              getTime={getTime}
                              company_id={company_id}
                              locationMasterList={locationMasterList}
                              setLocationMasterList={setLocationMasterList}
                              selectedOrg={selectedOrg}
                              superAdmins={superAdmins}
                              emailTemplate={emailTemplate}
                            />
                          }
                          title="Edit Location Master"
                          id="locationmaster"
                          size="lg"
                          screenName="location master - edit"
                          moduleName="location master - edit"
                        />
                      <button
                        className="btn btn-link text-dark "
                        onClick={(e) => deleteHandler(e, locationMaster)}
                          style={{}}
                          disabled={canedit || !canUpdate}
                        >
                          <i
                            className={`${classes["edit-option"]} fa fa-trash `}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </table>
    </div>
  );
};

export default LocationMasterTable;
